import { put } from 'redux-saga/effects';
import { apiEndPoints } from '../../../services/axios/endPoints';
import { WebService } from '../../../services/axios/webServices';
import { Creators } from './action';
import { sagaCatchBlockHandling } from '../../../store/utility/sagaErrorHandling';

export function* getEquipmentsListSaga({ payload }) {
  const { page, pageSize, searchParams } = payload;

  try {
    yield put(Creators.getEquipmentsListStart());
    const response = yield WebService.post(
      `${apiEndPoints?.getEquipmentList}/${page || 1}/${pageSize || 10}`,
      {
        SearchFilters: { ...searchParams }
      }
    );
    if (response.status >= 200 && response.status < 300) {
      const { data, meta, Count, CanEdit, CanChangePassword, CanAdd } =
        response.data;
      const equipmentPermissions = { CanEdit, CanChangePassword, CanAdd };
      yield put(
        Creators.getEquipmentsListSuccess({
          data,
          meta,
          Count,
          equipmentPermissions
        })
      );
    } else {
      throw response;
    }
  } catch (error) {
    const { error: err } = sagaCatchBlockHandling(error);
    yield put(Creators.getEquipmentsListFailure(err));
  }
}
